import Cookies from 'js-cookie'

const UIdKey = 'userId'
const OpenIdKey = 'openId'
const TokenKey = 'token'

export function getUid() {
  return parseInt(Cookies.get(UIdKey))
}

export function setUid(uid) {
  return Cookies.set(UIdKey, uid)
}

export function removeUid() {
  return Cookies.remove(UIdKey)
}

export function getOpenId() {
  return Cookies.get(OpenIdKey)
}

export function setOpenId(id) {
  return Cookies.set(OpenIdKey, id)
}

export function removeOpenId() {
  return Cookies.remove(OpenIdKey)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/store/cookies.js